<div role="search">
  <mat-form-field
    class="search-container compact-field"
    subscriptSizing="dynamic"
    appearance="outline"
  >
    <input
      matInput
      class="custom-search-input"
      type="text"
      #searchInput
      [(ngModel)]="searchText"
      debounceKeyup
      (textChanged)="emitTextChanged()"
      [placeholder]="placeholder"
      [ngClass]="{
        'left-align': iconDirection !== 'right',
        'right-align': iconDirection === 'right'
      }"
      id="search-input"
      aria-label="Search bar"
    />
    <button
      mat-icon-button
      matPrefix
      (click)="searchInput.focus()"
      aria-label="Search"
      id="search-button"
    >
      <mat-icon class="md-24">search</mat-icon>
    </button>
  </mat-form-field>
</div>
